import { createApp } from 'vue'
import { ActionBar, ActionBarIcon, ActionBarButton, Divider, Popup, Overlay, Loading, Dialog, ContactCard, Form, AddressEdit, AddressList, Field, CellGroup, Cell, SwipeCell, Icon, Stepper, Card, Checkbox, CheckboxGroup, Button, Swipe, SwipeItem, PullRefresh, List, Tab, Tabs, SubmitBar, Toast, Skeleton, Picker, Area, CountDown, Image, Lazyload, IndexAnchor, IndexBar, Col, Row, Sticky, Search, Tag, Uploader, DatetimePicker, NoticeBar, Calendar, Cascader, ActionSheet, Popover } from 'vant'
import store from './store'
import router from './router'
import App from './App.vue'
import 'lib-flexible/flexible'
import '@/assets/style/reset.css'
import 'vant/lib/index.css'; // 全局引入样式
import '@/assets/style/vant.css'
import '@/assets/iconfont/iconfont.css'
import { getQueryString } from '@/utils/common'
import VConsole from 'vconsole';
// import VuePdf from 'vue3-pdfjs'
import VueLuckyCanvas from '@lucky-canvas/vue'
import animated from 'animate.css'
// import SlideVerify from 'vue-monoplasty-slide-verify'


// sessionStorage.setItem('huijuToken', '0c77fb3c886d42c6993d94f8b662ad2a')


const app = createApp(App) // 创建实例

// app.config.ignoredElements = [
//   'wx-open-launch-weapp',
//   'wx-open-subscribe',
// ]

// 全局过滤器
app.config.globalProperties.$filters = {
  moneyFilter(val) {
    let money = (Number(val) / 100).toFixed(2).split(".");
    money[0] = money[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return money.join(".");
  },
  moneyNoFixedFilter(val) {
    let money = (Number(val) / 100).toFixed().split(".");
    money[0] = money[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return money.join(".");
  },
  prefix(url) {
    return url
    // if (url && url.startsWith('http')) {
    //   return url
    // } else {
    //   url = `http://backend-api-01.newbee.ltd${url}`
    //   return url
    // }
  }
}
app.use(VueLuckyCanvas)
app.use(animated)

app.use(ActionBarButton)
  .use(ActionBarIcon)
  .use(ActionBar)
  .use(Divider)
  .use(Popup)
  .use(Overlay)
  .use(Loading)
  .use(Dialog)
  .use(Toast)
  .use(ContactCard)
  .use(Form)
  .use(AddressEdit)
  .use(AddressList)
  .use(Field)
  .use(CellGroup)
  .use(Cell)
  .use(SwipeCell)
  .use(Icon)
  .use(Stepper)
  .use(Card)
  .use(Button)
  .use(Swipe)
  .use(SwipeItem)
  .use(PullRefresh)
  .use(List)
  .use(Tab)
  .use(Tabs)
  .use(SubmitBar)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Skeleton)
  .use(Picker)
  .use(Area)
  .use(CountDown)
  .use(IndexBar)
  .use(IndexAnchor)
  .use(Image)
  .use(Lazyload)
  .use(Col)
  .use(Row)
  .use(Sticky)
  .use(Search)
  .use(Tag)
  .use(Uploader)
  .use(DatetimePicker)
  .use(NoticeBar)
  .use(Calendar)
  .use(Cascader)
  .use(ActionSheet)
  .use(Popover)

// app.use(SlideVerify)
app.use(router)
app.use(store)
// app.use(VuePdf)
app.mount('#app')

// 判断URL如果存在vConsole参数为1，就加载vConsole
if (getQueryString('vConsole') === '1') {
  localStorage.setItem('vConsole', '1')
} else if (getQueryString('vConsole') === '0') {
  localStorage.removeItem('vConsole')
}

if (localStorage.getItem('vConsole')) {
  // eslint-disable-next-line
  const vConsole = new VConsole()
}
